import { Amplify } from 'aws-amplify';

import { Environment } from '@brightside-web/micro/core/environment';

import { InjectedInformation } from '@brightside-web/micro/core/authorization';

declare let Injected: InjectedInformation;
declare global {
  interface Window {
    Injected: InjectedInformation;
  }
}

export class AmplifyConfigure {
  constructor() {}

  get oneTimeUseUUID() {
    let d = new Date().getTime(); //Timestamp
    let d2 = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = Math.random() * 16; //random number between 0 and 16
      if (d > 0) {
        //Use timestamp until depleted
        // eslint-disable-next-line no-bitwise
        r = (d + r) % 16 | 0;
        d = Math.floor(d / 16);
      } else {
        //Use microseconds since page-load if supported
        // eslint-disable-next-line no-bitwise
        r = (d2 + r) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      // eslint-disable-next-line no-bitwise
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  public setUpConfig(environment: Environment) {
    //sso domain for hosted ui
    const domain = environment.hostedDomain;
    let location = window.location.origin;
    if (!location.endsWith('/')) {
      location = `${location}/`;
    }

    Amplify.configure({
      API: {
        REST: {
          'api-mobile': {
            endpoint: environment.awsmobile.endpoints['api-mobile'].endpoint,
            region: 'us-west-2',
          },
          'api-mobile-noauth': {
            endpoint: environment.awsmobile.endpoints['api-mobile-noauth'].endpoint,
            region: 'us-west-2',
          },
          'cdn-mobile-noauth': {
            endpoint: environment.awsmobile.endpoints['cdn-mobile-noauth'].endpoint,
            region: 'us-west-2',
          },
        },
      },
    });
  }
}
